export const CSHARP_RUN_HELP = [
    '/*',
    '  SharpLab tools in Run mode:',
    '    • value.Inspect()',
    '    • Inspect.Heap(object)',
    '    • Inspect.Stack(value)',
    '    • Inspect.MemoryGraph(value1, value2, …)',
    '*/'
].join('\r\n');